/**
 * Clase para manejar las traducciones.
 */
export default class Translations {
    static #instance = null;
    #translations = {};

    static i() {
        if (!this.#instance) {
            this.#instance = new this();
        }

        return this.#instance;
    }

    /**
     * Establece las traducciones a usar.
     * @param {object} translations Traducciones a usar.
     */
    setTranslations(translations) {
        if (translations) {
            this.#translations = translations;
        }
    }

    /**
     * Añade las traducciones a usar.
     * @param {object} translations Traducciones a usar.
     */
    addTranslations(translations) {
        if (translations) {
            if (this.#translations) {
                Object.assign(this.#translations, translations);
            } else {
                this.setTranslations(translations);
            }
        }
    }

    /**
     * Traduce el texto pasado.
     * @param {string} label - Texto a traducir
     * @param {Array|object} placeholders - Argumentos a sustituir en el texto
     * @returns {string}
     */
    tr(label, placeholders) {
        let text = this.#translations[label] ?? label;
        if (placeholders) {
            if (Array.isArray(placeholders)) {
                placeholders.forEach((arg, index) => (text = text.replace(`{${index}}`, arg)));
            } else {
                Object.keys(placeholders).forEach((name) => (text = text.replace(`{${name}}`, placeholders[name])));
            }
        }

        return text;
    }
}
